import { isEqual, isEqualNegative, isEqualAbs, isNumber, isEqual as isEqualDefault, } from '@cornerstonejs/utils';
export { isEqual, isEqualNegative, isEqualAbs, isNumber };
export default isEqualDefault;
